module.exports = __webpack_public_path__ + "static/img/btn2.a417be1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloads/btn2.png
// module id = 9KKS
// module chunks = 0